

import { request } from "@weapp/utils";

//获取团队分享
export const getData = (data: any) => {
    return request({
        // url: `/api/app/basicserver/teamshare/workdyna`,
        url: `/api/blog/teamshare/workdyna`,
        method: "post",
        data,
    });
};

//发布团队分享
export const publish = (data: any) => {
    return request({
        // url: `/api/app/basicserver/teamshare/publish`,
        url: `/api/blog/teamshare/publish`,
        method: "POST",
        data,
    });
};

//加载我关注的
export const loadMyfollow = (params: any) => {
    return request({
        url: `/api/hrm/user/myfollow/${window.TEAMS.currentUser.id}`,
        method: "get",
        params
    });
};

//加载我的下属
export const loadSubordinate = (params: any) => {
    return request({
        url: `/api/hrm/user/subordinate/${window.TEAMS.currentUser.id}`,
        method: "get",
        params
    });
};

//点赞
export const praise = (data: any) => {
    return request({
        // url: `/api/app/basicserver/teamshare/praise`,
        url: `/api/blog/teamshare/praise`,
        method: "post",
        data
    });
};


//删除团队分享数据
export const deleteTeamSharing = (data: any) => {
    return request({
        url: `/api/blog/teamshare/deleteShare`,
        method: "POST",
        data,
    });
};

//删除分享附件
export const deleteItemFile = (blogId: string, id: string) => {
    return request({
        url: `/api/blog/prior/deleteAttachmentsShare/${id}/${blogId}`,
        method: "DELETE",
    });
};